export default __webpack_public_path__ + "5c0fac6158984f420198c64f74b28922.png";